import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import allProductsListingApi from "../../api/allProductsListing";
import { Breadcrumb } from "react-bootstrap";
import Breadcrump from "../../Components/Breadcrump";

const ProductDetail = () => {
  const { slug } = useParams();

  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(0);

  const cleanImage = (url) => {
    if (!url) return "";
    return url.replace(/\[|\]|\(.*?\)/g, "");
  };

  const fetchProduct = async () => {
    try {
      const res = await allProductsListingApi.details(slug);

      if (res.code === 200) {
        const products = res.data || {};

        if (!products) {
          setLoading(false);
          return;
        }

        setProduct(products);
      }
    } catch (err) {
      console.error("ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
    setActiveImage(0);
  }, [slug]);

  if (loading) return <div>Loading...</div>;
  if (!product) return <div>Product not found</div>;

  const images = product?.images?.length
    ? product.images.map((img) => cleanImage(img.image))
    : [];

  const inStock = Number(product.stock) > 0;

  return (
    <>
      <Breadcrump title="Details" />
    <div className="container main-section">
      <div className="row">
        {/* LEFT — GALLERY */}
        <div className="col-lg-6 col-md-6">
          <div className="custom-left-sticky">
            <div className="editorial-gallery">
              <div className="secondary-img">
                <img
                  src={images[activeImage]}
                  alt={product.name}
                />
              </div>

              {images.length > 1 && (
                <div className="product-thumb-row">
                  {images.map((img, i) => (
                    <div
                      key={i}
                      className={`product-thumb-item ${
                        i === activeImage ? "active" : ""
                      }`}
                      onClick={() => setActiveImage(i)}
                    >
                      <img src={img} alt={`${product.name}-${i}`} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT — DETAILS */}
        <div className="col-lg-6 col-md-6">
          <div className="tf-product-heading">
            {product.category?.name && (
              <span className="brand-tag">{product.category.name}</span>
            )}

            <h2 className="product-display-title">{product.name}</h2>

            {/* <div>
              <span className="product-price">
                ₹{product.price || "0.00"}
              </span>
              {product.compare_price && (
                <span className="price-tag">
                  ₹{product.compare_price}
                </span>
              )}
            </div> */}

            {/* <div className="mt-2">
              <span className="key-label">SKU:</span>{" "}
              <span>{product.sku || "N/A"}</span>
            </div> */}

            {product.category?.name && (
              <div>
                <span className="key-label">Category:</span>{" "}
                <span className="text-brown">{product.category.name}</span>
              </div>
            )}

            {/* <div className="product-stock">
              <span className={`stock ${inStock ? "in-stock" : "out-stock"}`}>
                {inStock ? "In Stock" : "Out of Stock"}
              </span>
            </div> */}

            {/* {!inStock && (
              <div className="product-progress-sale">
                <p className="title-hurry-up">
                  HURRY UP! Only <span className="count">{product.stock ?? 0}</span> items left!
                </p>
              </div>
            )} */}

            <hr />

            <div
              className="description-text"
              dangerouslySetInnerHTML={{
                __html: product.description || "<p>No description</p>",
              }}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ProductDetail;